import path from '../../assets/icons/path.svg';
import dollar from '../../assets/icons/icons-web-income.svg';
import { Home } from 'lucide-react';

export const TipsterRoutes = [
  {
    key: 'home',
    svg: Home,
    routes: [
      {
        key: 'home',
        active: true,
        path: '/',
      },
    ],
  },
  {
    key: 'tips',
    svg: path,
    routes: [
      {
        key: 'publish',
        active: true,
        path: '/pc',
      },
      {
        key: 'close',
        active: true,
        path: '/my-bets',
      },
    ],
  },
  // {
  //   key: 'stats',
  //   svg: stats,
  //   routes: [
  //     {
  //       key: 'users (beta)',
  //       active: true,
  //       path: '/user-stats',
  //     },
  //   ],
  // },
  {
    key: 'monetization',
    svg: dollar,
    routes: [
      {
        key: 'sales',
        active: true,
        path: '/sales',
      },
      {
        key: 'balance',
        active: true,
        path: '/balance',
      },
      // {
      //   key: 'payouts',
      //   active: true,
      //   path: '/payouts',
      // },
    ],
  },

  // {key: other
  //TODO: add news
  //   }
];
export const UserRoutes = [
  // {
  //   key: 'home',
  //   svg: coins,
  //   active: true,
  //   path: '/home',
  // },
];
